// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__23t1j","header":"ReportDetails_header__3kGyR","title":"ReportDetails_title__3Mwi1","left":"ReportDetails_left__3NXOu"};